import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VSimpleTable } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
import data from '@/assets/docs/beos-img.json';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosImgDemo',
    setup(__props) {
        const basicUsage = '<beos-img src="path/to/image.png" max-width="150" />';
        const aspectUsage = '<beos-img src="https://picsum.photos/..." aspect-ratio="1.7" />';
        const objectFitUsage = '<beos-img src="path/to/image.png" height="150" :cover="false" />';
        const propsDocs = ref(data.props);
        const slotsDocs = ref(data.slots);
        return { __sfc: true, basicUsage, aspectUsage, objectFitUsage, propsDocs, slotsDocs, VContainer, VRow, VCol, VSimpleTable, DemoSection, CodePreview };
    }
});
